import React from "react";
import { styled } from "@mui/material";
import { convertPxToRem } from "@treez-inc/component-library";
import { ReactComponent as TreezLogo } from "assets/treez-logo.svg";

const StyledTreezLogo = styled(TreezLogo)({
  width: convertPxToRem(70),
  height: convertPxToRem(23),
  marginBottom: convertPxToRem(20),
});

const Divider = styled("div")(({ theme }) => ({
  marginBottom: convertPxToRem(42),
  borderBottom: `${convertPxToRem(1)} solid ${theme.palette.grey05.main}`,
  width: "100%",
}));

const Header: React.FC = () => (
  <div data-testid="treez-header">
    <StyledTreezLogo data-testid="treez-logo" />
    <Divider />
  </div>
);

export default Header;
